import api from "./api";

/**
 * Aceite de termos. O gateway (apim2-web) injeta idCliente e idLogin a partir do token —
 * nenhuma chamada daqui envia identificação do cliente.
 */

export interface TermoPendencia {
  idTermNotice: number;
  idTermVersion: number;
  termTypeCode: string;
  tipoNome?: string | null;
  titulo: string;
  versao: string;
  resumo?: string | null;
  /** Documento já renderizado com os dados do cliente. */
  html?: string | null;
  hashRenderizado?: string | null;
  erroDocumento?: string | null;
  bloqueante: boolean;
  publicadoEm: string;
  prazoAte: string;
  diasRestantes: number;
  vencido: boolean;
  exigeOtp: boolean;
  /** Devolver no aceite: carrega o momento em que o termo foi exibido. */
  tokenExibicao: string;
}

export interface TermosPendencias {
  podeAceitar: boolean;
  motivoBloqueioAceite?: string | null;
  /** Recusou ou perdeu o prazo: o portal fica barrado até a central tratar. */
  bloqueado: boolean;
  mensagemBloqueio?: string | null;
  bloqueantes: TermoPendencia[];
  avisos: TermoPendencia[];
}

export interface TermoAceiteResposta {
  idTermAcceptance: number;
  tipoEvento: string;
  statusAviso: string;
  registradoEm: string;
  hashRegistro: string;
  bloqueado: boolean;
}

/**
 * Um termo que o estabelecimento recebeu — decidido ou não. A lista parte dos avisos,
 * não dos aceites, para o cliente conseguir reler também o que ainda está pendente.
 */
export interface MeuTermo {
  idTermNotice: number;
  idTermVersion: number;
  titulo: string;
  resumo?: string | null;
  termTypeCode: string;
  versao: string;
  /** PENDENTE | ACEITO | RECUSADO | EXPIRADO | SUPERADO | CANCELADO */
  status: string;
  publicadoEm: string;
  prazoAte: string;
  vencido: boolean;
  podeVisualizar: boolean;
  idTermAcceptance?: number | null;
  tipoEvento?: string | null;
  aceito?: boolean | null;
  decididoEm?: string | null;
  decididoPor?: string | null;
  motivoRecusa?: string | null;
  hashRenderizado?: string | null;
  hashRegistro?: string | null;
}

const BASE = "/portal/termos";

export default class TermosApi {
  static getPendencias = async (): Promise<TermosPendencias> => {
    const response = await api.get(`${BASE}/pendencias`);
    return response.data;
  };

  static registrarExibicao = async (
    idTermVersion: number,
    rolouAteFim?: boolean
  ) => {
    const response = await api.post(`${BASE}/exibicao`, {
      idTermVersion,
      rolouAteFim,
    });
    return response.data;
  };

  static aceitar = async (
    idTermVersion: number,
    tokenExibicao: string,
    geo?: { lat?: number; lon?: number }
  ): Promise<TermoAceiteResposta> => {
    const response = await api.post(`${BASE}/aceitar`, {
      idTermVersion,
      tokenExibicao,
      geoLat: geo?.lat,
      geoLon: geo?.lon,
    });
    return response.data;
  };

  static recusar = async (
    idTermVersion: number,
    tokenExibicao: string,
    motivoRecusa: string,
    geo?: { lat?: number; lon?: number }
  ): Promise<TermoAceiteResposta> => {
    const response = await api.post(`${BASE}/recusar`, {
      idTermVersion,
      tokenExibicao,
      motivoRecusa,
      geoLat: geo?.lat,
      geoLon: geo?.lon,
    });
    return response.data;
  };

  static getMeusTermos = async (): Promise<MeuTermo[]> => {
    const response = await api.get(`${BASE}/meus-termos`);
    return response.data;
  };

  static getDocumento = async (idTermVersion: number) => {
    const response = await api.get(
      `${BASE}/documento?idTermVersion=${idTermVersion}&html=false`
    );
    return response.data;
  };

  static getBloqueio = async () => {
    const response = await api.get(`${BASE}/bloqueio`);
    return response.data;
  };
}
